import type { components } from '@fluencelabs/vodopad-admin-api'
import { type TableColumnsType, Typography } from 'antd'

import { ConfirmSwitch } from '@/components/common/ConfirmSwitch'
import { FormattedDate } from '@/components/common/FormattedDate'

type PromoCodeDto = components['schemas']['PromoCodeDto']

export function promoCodeColumns(
  onToggleActive: (record: PromoCodeDto, checked: boolean) => Promise<void>,
): TableColumnsType<PromoCodeDto> {
  return [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      render: (code: string) => (
        <Typography.Text copyable>{code}</Typography.Text>
      ),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      width: 100,
      render: (v: string) => `$${Number(v).toFixed(2)}`,
    },
    {
      title: 'Active',
      dataIndex: 'isActive',
      key: 'isActive',
      width: 80,
      render: (active: boolean, record: PromoCodeDto) => (
        <ConfirmSwitch
          checked={active}
          size="small"
          target={`promo code ${record.code}`}
          onLabel="Activate"
          offLabel="Deactivate"
          onConfirm={(checked) => onToggleActive(record, checked)}
        />
      ),
    },
    {
      title: 'Max Usages',
      dataIndex: 'maxTotalUsages',
      key: 'maxTotalUsages',
      width: 110,
    },
    {
      title: 'Free Days',
      dataIndex: 'freeCreditsDurationDays',
      key: 'freeCreditsDurationDays',
      width: 100,
    },
    {
      title: 'Valid From',
      dataIndex: 'validFrom',
      key: 'validFrom',
      width: 120,
      render: (d: string) => <FormattedDate date={d} />,
    },
    {
      title: 'Valid To',
      dataIndex: 'validTo',
      key: 'validTo',
      width: 120,
      render: (d: string) => <FormattedDate date={d} />,
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 120,
      render: (d: string) => <FormattedDate date={d} />,
    },
  ]
}
